import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import moment from 'moment';
import { UtilsService } from './utils.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  // Family data management
  private familyDataSubject = new BehaviorSubject<any>(null);
  public familyData$ = this.familyDataSubject.asObservable();
  
  freeTier = {
    tier: 0,
    slug: "tier-0",
    name: "Starter",
    shortName: "Starter",
    price: 0,
    priceString: "features.free",
    features: [
      "features.stayClose",
      "features.recallersStarter",
      "features.realTimeLocation",
      "features.batteryStatus",
    ] 
  }

  plans = [
    {
      id: 1,
      tier: 1,
      slug: environment.premium_slug,
      duration_months: 12,
      duration: "yearly",
      name: "Premium Individual",
      shortName: "Individual",
      price: environment.premium_price,
      price_id: environment.premium_price_id,
      priceString: environment.premium_price + " € / anno",
      members: environment.premium_members,
      // offerText: "planCard.forYou",
      // offerDiscount: 32,
      // oldPrice: 14.99,
    },
  ]

  newPlans = [
    {
      id: 1,
      tier: 1,
      slug: environment.premium_slug,
      duration_months: 12,
      duration: "yearly",
      name: "Premium Individual",
      shortName: "Individual",
      price: environment.premium_price,
      price_id: environment.premium_price_id,
      priceString: environment.premium_price + " € / anno",
      members: environment.premium_members,
      // offerText: "planCard.forYou",
      // offerDiscount: 32,
      // oldPrice: 14.99,
    },
    {
      id: 2,
      tier: 1,
      slug: environment.duo_slug,
      duration_months: 12,
      duration: "yearly",
      name: "Premium Duo",
      shortName: "Duo",
      price: environment.duo_price,
      price_id: environment.duo_price_id,
      priceString: environment.duo_price + " € / anno",
      members: environment.duo_members,
    },
    {
      id: 3,
      tier: 1,
      slug: environment.family_slug,
      duration_months: 12,
      duration: "yearly",
      name: "Premium Family",
      shortName: "Family",
      price: environment.family_price,
      price_id: environment.family_price_id,
      priceString: environment.family_price + " € / anno",
      members: environment.family_members,
      bestChoice: true,
    },
  ];

  // Gift cards disponibili per l'acquisto
  giftCards = [
    {
      id: 1,
      slug: 'gift-card-individual',
      name: "giftCard.individual",
      shortName: "Individual",
      price: environment.gift_card_individual_price,
      price_id: environment.gift_card_individual_price_id,
      members: 1,
    },
    {
      id: 2,
      slug: 'gift-card-duo',
      name: "giftCard.duo",
      shortName: "Duo",
      price: environment.gift_card_duo_price,
      price_id: environment.gift_card_duo_price_id,
      members: 2,
    },
    {
      id: 3,
      slug: 'gift-card-family',
      name: "giftCard.family",
      shortName: "Family",
      price: environment.gift_card_family_price,
      price_id: environment.gift_card_family_price_id,
      members: 5,
    },
  ];

  hiddenPlans = [
    {
      id: 1,
      tier: 1,
      slug: environment.lifetime_slug,
      duration_months: 12,
      duration: "yearly",
      name: "Premium Individual",
      shortName: "Individual",
      price: environment.lifetime_price,
      price_id: environment.lifetime_price_id,
      priceString: environment.lifetime_price + " € / anno",
      members: environment.premium_members,
      // offerText: "planCard.forYou",
      // offerDiscount: 32,
      // oldPrice: 14.99,
    },
    {
      id: 1,
      tier: 1,
      slug: environment.reduced_slug,
      duration_months: 12,
      duration: "yearly",
      name: "Premium Individual",
      shortName: "Individual",
      price: environment.premium_price,
      price_id: environment.premium_price_id,
      priceString: environment.premium_price + " € / anno",
      members: environment.premium_members,
      // offerText: "planCard.forYou",
      // offerDiscount: 32,
      // oldPrice: 14.99,
    },
    {
      id: 1,
      tier: 1,
      slug: environment.over70_slug,
      duration_months: 12,
      duration: "yearly",
      name: "Premium Individual",
      shortName: "Individual",
      price: environment.over70_price,
      price_id: environment.over70_price_id,
      priceString: environment.over70_price + " € / anno",
      members: environment.over70_members,
      offerText: "planCard.forYou",
      offerDiscount: 32,
      oldPrice: 14.99,
    },
  ]

  showNewPlans = false;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private utils: UtilsService,
    private translate: TranslateService
  ) {
    this.getPlans();
    this.checkNewPlansRelease();
  }


  getPlans() {
    //Inserire api per ottenere i piani direttamente da db
    if(this.showNewPlans) {
      // Se l'utente ha più di 70 anni, ritorna newPlans sostituendo id 1 con over-70 da hiddenPlans
      const birthDate = this.auth.account?.birthDate ? new Date(this.auth.account.birthDate) : null;
      if (birthDate) {
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear() - (today.getMonth() < birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate()) ? 1 : 0);
        console.log('Age:', age);
        if (age >= 70) {
          // Sostituisci il piano con id 1 con quello over-70 da hiddenPlans
          const over70Plan = this.hiddenPlans.find(x => x.slug === environment.over70_slug);
          if (over70Plan) {
            // Crea una copia di newPlans e sostituisci il piano con id 1
            let plansCopy = this.newPlans.map(plan => plan.id === 1 ? over70Plan : plan);
            
            // Aggiungi il free trial se è la prima sottoscrizione
            console.log('User has first sub:' + this.auth.account?.subscription?.trialEligible);
            if (this.auth.account?.subscription === null || this.auth.account?.subscription?.trialEligible) {
              plansCopy = plansCopy.map(plan => plan.id === 1 ? { ...plan, trialText: "planCard.freeTrial", trialDays: environment.trial_days, hasTrial: true } : plan);
            }
            
            // Applica la promozione se attiva (sovrascrive il trial)
            if (this.isPromotionActive()) {
              plansCopy = plansCopy.map(plan => {
                if (plan.id === 1) {
                  return { 
                    ...plan, 
                    hasTrial: undefined,
                    trialText: undefined,
                    trialDays: undefined,
                    promotionText: "planCard.promotionText", 
                    hasPromotion: true 
                  };
                }
                return plan;
              });
            }
            
            return plansCopy;
          }
        }
      }

      console.log('User has first sub:' + this.auth.account?.subscription?.trialEligible);
      let plansCopy = this.newPlans;
      
      if (this.auth.account?.subscription === null || this.auth.account?.subscription?.trialEligible) {
        plansCopy = plansCopy.map(plan => plan.id === 1 ? { ...plan, trialText: "planCard.freeTrial", trialDays: environment.trial_days, hasTrial: true } : plan);
      }
      
      // Applica la promozione se attiva (sovrascrive il trial e si applica anche a chi non ha diritto al trial)
      if (this.isPromotionActive()) {
        plansCopy = plansCopy.map(plan => {
          if (plan.id === 1) {
            return { 
              ...plan, 
              hasTrial: undefined,
              trialText: undefined,
              trialDays: undefined,
              promotionText: "planCard.promotionText", 
              hasPromotion: true 
            };
          }
          return plan;
        });
      }
      
      return plansCopy;
    }
    else {
      return this.plans;
    }
  }

  getCurrentPlan() {
    if(!this.showNewPlans) {
      return this.plans.find(x => x.tier == this.auth.account?.subscription?.type.tier) ?? this.freeTier;
    }
    else {
      if(this.auth.account?.subscription?.type.slug === 'tier-1-six-months') {
        return this.newPlans.find(x => x.slug == 'tier-1-yearly-plan') ?? 
        this.hiddenPlans.find(x => x.slug == 'tier-1-yearly-plan') ?? this.freeTier;
      }
      
      return this.newPlans.find(x => x.slug == this.auth.account?.subscription?.type.slug) ?? 
      this.hiddenPlans.find(x => x.slug == this.auth.account?.subscription?.type.slug) ?? this.freeTier;
    }
  }

  getExpireString(): string {
    const expirationDate = moment(this.getExpirationDate());
    const formattedDay = expirationDate.format('D ');
    const formattedMonth = expirationDate.format('MMMM ').charAt(0).toUpperCase() + expirationDate.format('MMMM ').slice(1);
    const formattedYear = expirationDate.format('YYYY');

    return formattedDay+formattedMonth+formattedYear;
  }

  private getExpirationDate(): string {
    return this.auth.account?.subscription?.expiresAt || '';
  }

  getCurrentPeriodStartString(): string {
    const currentPeriodStart = moment(this.getCurrentPeriodStart()).add(environment.gracePeriodDays, 'days');
    const formattedDay = currentPeriodStart.format('D ');
    const formattedMonth = currentPeriodStart.format('MMMM ').charAt(0).toUpperCase() + currentPeriodStart.format('MMMM ').slice(1);
    const formattedYear = currentPeriodStart.format('YYYY');

    return formattedDay+formattedMonth+formattedYear;
  }

  private getCurrentPeriodStart(): string {
    return this.auth.account?.subscription?.currentPeriodStart || '';
  }

  getOthersPlan() {
    const currentTier = this.auth.account?.subscription?.type.tier;
    return currentTier 
      ? this.plans.filter(x => x.tier !== currentTier) 
      : this.plans;
  }

  // getNewPlans() {
  //   return this.newPlans;
  // }

  getGiftCards() {
    return this.giftCards;
  }

  giftCardCheckoutSession(giftCard: any, quantity: number) {
    return new Promise((resolve, reject) => {
      this.http.get(
        environment.api_url + '/payments/gift-cards-checkout-session?stripe_price_id=' + giftCard.price_id + '&quantity=' + quantity
      ).subscribe(
        (res: any) => {
          if (res && res.url) {
            const response: any = res;
            console.log(res);
            window.location.href = response.url;
            resolve('Apertura checkout session gift card');
          }
        },
        err => {
          console.log(err);
          reject(err.error);
        }
      );
    });
  }

  featureComparison = [
    {
      name: "featuresV2.receiveNotifications",
      free: true,
      premium: true
    },
    {
      name: "featuresV2.stayClose",
      free: false,
      premium: true
    },
    {
      name: "featuresV2.helpMe",
      free: false,
      premium: true
    },
    {
      name: "featuresV2.voiceCommand",
      free: false,
      premium: true
    },
    {
      name: "featuresV2.accelerometer",
      free: false,
      premium: true
    },
    {
      name: "featuresV2.recallers",
      free: false,
      premium: true
    }
  ]

  getFeatureComparison() {
    return this.featureComparison;
  }

  checkoutSession(plan: any) {
    return new Promise((resolve, reject) => {

      // const body = {
      //   subscription_slug: plan.slug,
      //   stripe_price_id: plan.price_id
      // };

      this.http.post(environment.api_url + '/payments/checkout-session?subscription_slug='+plan.slug+'&stripe_price_id='+plan.price_id, {}).subscribe(
        (res: any) => {
          if (res && res.url) {
            // auth standard - return token
            const response: any = res;
            console.log(res);

            window.location.href = response.url;

            resolve('Apertura checkout session');
          }
        },
        err => {
          console.log(err);
          reject(err.error);
        }
      );
    });
  }

  billingPortal() {
    return new Promise((resolve, reject) => {

      // const body = {
      //   subscription_slug: plan.slug,
      //   stripe_price_id: plan.price_id
      // };

      this.http.get(environment.api_url + '/payments/billing-portal-session').subscribe(
        (res: any) => {
          if (res && res.url) {
            // auth standard - return token
            const response: any = res;
            console.log(res);

            window.location.href = response.url;

            resolve('Apertura checkout session');
          }
        },
        err => {
          console.log(err);
          reject(err.error);
        }
      );
    });
  }

  public redeemCode(data: any) {
    console.log('Riscatta codice:', data);

    // Determina l'endpoint in base al prefisso del codice
    const isGiftCard = data.code && data.code.toUpperCase().startsWith('GC');
    const giftCardEndpoint = '/gift-cards/redeem-gift-card?code=' + data.code;
    const standardEndpoint = '/subscription/redeem-code?code=' + data.code;
    const endpoint = isGiftCard ? giftCardEndpoint : standardEndpoint;

    return new Promise((resolve, reject) => {
      this.http.post(environment.api_url + endpoint, {}).subscribe(
        (res: any) => {
          console.log('Risposta del server:', res);
          if (res) {
            resolve('errors.codeRedeemSuccess');
          } else {
            reject('errors.codeGeneralError');
          }
        },
        (err) => {
          console.error('Errore nella richiesta:', err);
          
          // Se è una gift card e riceve 404, prova con l'endpoint standard
          if (isGiftCard && err.status === 404) {
            console.log('Gift card non trovata, provo con endpoint standard...');
            this.http.post(environment.api_url + standardEndpoint, {}).subscribe(
              (res: any) => {
                console.log('Risposta del server (fallback):', res);
                if (res) {
                  resolve('errors.codeRedeemSuccess');
                } else {
                  reject('errors.codeGeneralError');
                }
              },
              (fallbackErr) => {
                console.error('Errore nella richiesta fallback:', fallbackErr);
                this.handleRedeemError(fallbackErr);
                reject(fallbackErr);
              }
            );
            return;
          }

          this.handleRedeemError(err);
          reject(err);
        }
      );
    });
  }

  private handleRedeemError(err: any) {
    switch(err.status) {
      case 404:
        this.translate.get('errors.codeInvalid').subscribe((res: string) => {
          this.utils.openSnackBar(res, 'error');
        });
        break;
      case 400:
        this.translate.get('errors.codeAlreadyUsed').subscribe((res: string) => {
          this.utils.openSnackBar(res, 'error');
        });
        break;
      case 401:
        this.translate.get('errors.codeInvalid').subscribe((res: string) => {
          this.utils.openSnackBar(res, 'error');
        });
        break;
      case 412:
        this.translate.get('errors.codeAlreadyRedeemed').subscribe((res: string) => {
          this.utils.openSnackBar(res, 'error');
        });
        break;
      case 409:
        this.translate.get('errors.alreadyHasActivePlan').subscribe((res: string) => {
          this.utils.openSnackBar(res, 'error');
        });
        break;
      default:
        this.translate.get('errors.codeRedeemError').subscribe((res: string) => {
          this.utils.openSnackBar(res, 'error');
        });
        break;
    }
  }


  private checkNewPlansRelease() {
    if (environment.newPlansReleaseDate) {
      const releaseDate = new Date(environment.newPlansReleaseDate);
      const today = new Date();
      this.showNewPlans = today >= releaseDate;
      
      console.log('New Plans Release Check:');
      console.log('Release Date:', releaseDate);
      console.log('Current Date:', today);
      console.log('Show New Plans:', this.showNewPlans);
    }
  }

  isPromotionActive(): boolean {
    if (!environment.promotionStartDate || !environment.promotionEndDate) {
      return false;
    }
    const startDate = new Date(environment.promotionStartDate);
    const endDate = new Date(environment.promotionEndDate);
    const today = new Date();
    return today >= startDate && today <= endDate;
  }

  getPromotionEndDateFormatted(): string {
    if (!environment.promotionEndDate) {
      return '';
    }
    const endDate = moment(environment.promotionEndDate);
    const formattedDay = endDate.format('D');
    const formattedMonth = endDate.format('MMMM').charAt(0).toUpperCase() + endDate.format('MMMM').slice(1);
    return formattedDay + ' ' + formattedMonth;
  }

  // Invite user
  // 409 user already had a subscri

  // Get invitation details
  getInvitationDetails(joinCode: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.api_url}/subscription/family/invitation/${joinCode}`).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          console.error('Error loading invitation details:', err);
          reject(err);
        }
      );
    });
  }


  // Create/Regenerate invite link (usa sempre la stessa API)
  createInviteLink(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.api_url}/subscription/family/invitation/regenerate`).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          console.error('Error creating invite link:', err);
          reject(err);
        }
      );
    });
  }

  // Regenerate invite link (stessa API di create)
  regenerateInviteLink(): Promise<any> {
    return this.createInviteLink();
  }

  // Revoke invite link
  revokeInviteLink(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.delete(`${environment.api_url}/subscription/family/invitation`).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          console.error('Error revoking invite link:', err);
          reject(err);
        }
      );
    });
  }

  // Remove family member
  removeFamilyMember(username: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.api_url}/subscription/family/invitations/remove/${username}`, {}).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          console.error('Error removing family member:', err);
          reject(err);
        }
      );
    });
  }

  // Accept invitation
  acceptInvitation(joinCode: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.api_url}/subscription/family/accept-invitation/${joinCode}`, {}).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          console.error('Error accepting invitation:', err);
          reject(err);
        }
      );
    });
  }

  // Get family details
  getFamilyDetails(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.api_url}/subscription/family`).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          console.error('Error loading family details:', err);
          reject(err);
        }
      );
    });
  }

  // Exit from family plan
  exitPlan(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.delete(`${environment.api_url}/subscription/family/exit-plan`).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err) => {
          console.error('Error exiting plan:', err);
          reject(err);
        }
      );
    });
  }

  // Family data management methods
  getFamilyData(): any {
    return this.familyDataSubject.value;
  }

  setFamilyData(familyData: any): void {
    this.familyDataSubject.next(familyData);
  }

  getFamilyDataObservable(): Observable<any> {
    return this.familyData$;
  }

  // Load and set family data
  loadFamilyData(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getFamilyDetails().then(
        (data: any) => {
          this.setFamilyData(data);
          resolve(data);
        },
        (error) => {
          console.error('Error loading family data:', error);
          reject(error);
        }
      );
    });
  }

  // Clear family data
  clearFamilyData(): void {
    this.familyDataSubject.next(null);
  }
}
